export default import.meta.ROLLUP_FILE_URL_uuikitQnL64uJPdSSNt2Vw